import React, { useEffect, useRef, useState } from "react";
import Cropper from "react-cropper";
import LoaderBar from "./LoaderBar";
import { Modal } from "react-responsive-modal";
import "cropperjs/dist/cropper.css";

const CropperModel = ({
  title = "",
  open,
  closeModal,
  submitModal,
  is_loading,
  children,
  selectedFile,
}) => {
  const cropperRef = useRef(null);
  const onCrop = () => {
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;
    // console.log("cropper", cropper.getCroppedCanvas());
  };
  // const displayStyle = open ? "block" : "none";

  if (open) document.body.classList.add("scroll-none");
  else if (!open) document.body.classList.remove("scroll-none");

  const [displayStyle, setDisplayStyle] = useState("none");
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (open) {
      setDisplayStyle("block");
      setAnimate(true);
    } else {
      setAnimate(false);
      setDisplayStyle("none");
      // setTimeout(() => {
      //   setDisplayStyle("none");
      // }, 500);
    }
    return () => {
      cropperRef.current = null;
    };
  }, [open]);

  const submitBtnHandler = () => {
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;
    if (cropper.getCroppedCanvas()) {
      submitModal(cropper.getCroppedCanvas().toDataURL());
    }
  };

  return (
    <Modal open={open} onClose={() => closeModal(false)} center>
      <div
        className={`modal forgotModal`}
        id="forgot_modal"
        tabIndex="-1"
        aria-labelledby="loginModalLabel"
        aria-hidden="true"
        style={{ display: displayStyle }}
      >
        {open && (
          <div className={`modal-dialog modal-lg modal-dialog-scrollable`}>
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => closeModal(false)}
                >
                  <img src={`/img/circle-cross.svg`} />
                </button>
                <span className="titleName"> {title} </span>
              </div>
              <div className="modal-body pb-4">
                <div className="d-flex flex-md-nowrap flex-wrap">
                  <Cropper
                    src={selectedFile ? URL.createObjectURL(selectedFile) : ""}
                    style={{ height: "auto", width: "100%" }}
                    // Cropper.js options
                    // initialAspectRatio={1}
                    preview=".crop_preview"
                    aspectRatio={1}
                    viewMode={1}
                    guides={false}
                    crop={onCrop}
                    ref={cropperRef}
                  />
                  <div
                    style={{
                      height: "300px",
                      width: "300px",
                    }}
                  >
                    <div
                      className="crop_preview"
                      style={{
                        height: "300px",
                        width: "300px",
                        overflow: "hidden",
                        margin: "10px",
                        border: "1px solid red",
                        borderRadius: "50%",
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="invt-btns button">
                  {submitModal && (
                    <button
                      type="button"
                      onClick={() => {
                        if (!is_loading) submitBtnHandler();
                      }}
                      className="btn SaveBtn"
                    >
                      {is_loading ? (
                        <div class="spinner-border" role="status"></div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  )}
                  {closeModal && (
                    <button
                      type="button"
                      className="btn btn-danger"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => {
                        closeModal(false);
                      }}
                    >
                      Close
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default CropperModel;
